type OptionType = {
    value:
        | 'TextToImage'
        | 'ImageToImage'
        | 'Inpaint'
        | 'Avatar'
        | 'Upscale'
        | 'ClipEmbeddings'
        | 'Chat'
    label:
        | 'TextToImage'
        | 'ImageToImage'
        | 'Inpaint'
        | 'Avatar'
        | 'Upscale'
        | 'ClipEmbeddings'
        | 'Chat'
}

type ChatOptionType = {
    value: 'bittensor-finetune' | 'mixtral-8x7b' | 'llama-3'
    label: 'bittensor_finetune' | 'mixtral' | 'llama_3'
}

type EngineOptionType = {
    value: 'proteus' | 'dreamshaper' | 'playground'
    label: 'proteus' | 'dreamshaper' | 'playground'
}

export const synapseOptions: OptionType[] = [
    { value: 'TextToImage', label: 'TextToImage' },
    // { value: 'ImageToImage', label: 'ImageToImage' },
    // { value: 'Inpaint', label: 'Inpaint' },
    // { value: 'Avatar', label: 'Avatar' },
    // { value: 'Upscale', label: 'Upscale' },
    // { value: 'ClipEmbeddings', label: 'ClipEmbeddings' },
    { value: 'Chat', label: 'Chat' },
]

export const chatOptions: ChatOptionType[] = [
    { value: 'bittensor-finetune', label: 'bittensor_finetune' },
    { value: 'mixtral-8x7b', label: 'mixtral' },
    { value: 'llama-3', label: 'llama_3' },
]

export const enginesOptions: EngineOptionType[] = [
    { value: 'proteus', label: 'proteus' },
    { value: 'dreamshaper', label: 'dreamshaper' },
    { value: 'playground', label: 'playground' },
]

export const errorMessages: { [index: string]: string } = {
    axon_id: 'axon_id must be a positive number.',
    timeout: 'timeout must be a positive number.',
    width: 'width must be a positive number.',
    height: 'height must be a positive number.',
    cfg_scale: 'cfg_scale must be a positive number.',
    steps: 'steps must be a positive number.',
    seed: 'seed must be a positive number.',
    image_strength: 'image_strength must be a positive number.',
    ipadapter_strength: 'ipadapter_strength must be a positive number.',
    control_strength: 'control_strength must be a positive number.',
    temperature: 'temperature must be a positive number.',
    max_tokens: 'max_tokens must be a positive number.',
}

export interface VisionState {
    TextToImage: {
        text_prompts: {
            text: string
            weight: number | string
        }[]
        width: number | string
        height: number | string
        cfg_scale: number | string
        steps: number | string
        seed: number | string
    }
    ImageToImage: {
        seed: number | string
        steps: number | string
        cfg_scale: number | string
        init_image: string
        text_prompts: {
            text: string
            weight: number | string
        }[]
        image_strength: string
    }
    Avatar: {
        text_prompts: {
            text: string
            weight: number | string
        }[]
        ipadapter_strength: number | string
        control_strength: number | string
        height: number | string
        width: number | string
        steps: number | string
        seed: number | string
        init_image: string
    }
    Inpaint: {
        seed: number | string
        steps: number | string
        cfg_scale: number | string
        init_image: string
        mask_image: string
        text_prompts: {
            text: string
            weight: number | string
        }[]
    }
    ClipEmbeddings: {
        image_b64s: string[]
    }
    Upscale: {
        image: string
    }
    Chat: {
        messages: {
            role: string
            content: string
        }[]
        temperature: number | string
        max_tokens: number | string
        seed: number | string
        model: 'chat_model'
    }
}

export const visionInitialState: VisionState = {
    TextToImage: {
        text_prompts: [
            {
                text: 'Dog',
                weight: 1,
            },
        ],
        width: 1280,
        height: 1280,
        cfg_scale: 2,
        steps: 10,
        seed: 0,
    },
    ImageToImage: {
        seed: 0,
        steps: 5,
        cfg_scale: 3,
        init_image: '',
        text_prompts: [
            {
                text: 'cow',
                weight: 1,
            },
        ],
        image_strength: '0.5',
    },
    Avatar: {
        text_prompts: [
            {
                text: '',
                weight: 1,
            },
        ],
        ipadapter_strength: 0.5,
        control_strength: 0.5,
        height: 1024,
        width: 1024,
        steps: 8,
        seed: 0,
        init_image: '',
    },
    Inpaint: {
        seed: 0,
        steps: 5,
        cfg_scale: 3,
        init_image: '',
        mask_image: '',
        text_prompts: [
            {
                text: 'dog',
                weight: 1,
            },
        ],
    },
    ClipEmbeddings: {
        image_b64s: ['', ''],
    },
    Upscale: {
        image: '',
    },
    Chat: {
        messages: [
            {
                role: 'user',
                content: 'Remind me that I have forgot to set the messages',
            },
        ],
        temperature: 0.1,
        max_tokens: 500,
        seed: 123,
        model: 'chat_model',
    },
}
